import { useQuery } from "react-query";

import { axiosAsync } from "../api/abortableAxiosConfig";

import { partnerSearchListV2 } from "../api/user/userPartnerAxiosConfig";

// //*파트너 관리
// export const useGetPaybackPartner = (enabled: boolean = true) => {
//     const fetchPaybackPartner = async () => {
//         const response = await xapi.get(`${userPartner}`, {
//             timeout: 10000,
//         });
//         return response?.data;
//     };

//     return useQuery<IPartnerInfoType>(['useGetPaybackPartner'], fetchPaybackPartner, {
//         enabled,
//     });
// };

// //*파트너 신청
// export const useSaverApplicationPaybackPartner = (
//     onSuccess: (datum: any) => void = () => {},
//     onError: (err: AxiosError) => void = () => {},
// ) => {
//     return useMutation(
//         async ({ name, reference }: { name: string; reference: string }) => {
//             try {
//                 const res = await xapi.put(userPartner, { name, reference });
//                 return res;
//             } catch (Err) {
//                 console.log('saveError>>', Err);
//                 throw Err;
//             }
//         },
//         {
//             onSuccess: onSuccess,
//             onError: onError,
//         },
//     );
// };

// //* 파트너 혜택
// export const useGetPaybackPartnerBenefit = (enabled: boolean = true) => {
//     const fetchPaybackPartnerBenefit = async () => {
//         const response = await xapi.get(`${userPartnerBenefit}`);
//         return response?.data;
//     };
//     return useQuery<IBenefitPartnerType>(['useGetPaybackPartnerBenefit'], () => fetchPaybackPartnerBenefit(), {
//         enabled,
//     });
// };

// //* 내 파트너 조회
// export const useGetPaybackPartnerConnection = (enabled: boolean = true) => {
//     const fetchPaybackPartnerConnection = async () => {
//         const response = await xapi.get(`${userPartnerConnection}`);
//         return response?.data;
//     };
//     return useQuery<IConnectionPartnerType>(['useGetPaybackPartnerConnection'], () => fetchPaybackPartnerConnection(), {
//         enabled,
//     });
// };

// //* 내 파트너 연결
// export const useSaverConnectionPaybackPartner = (
//     onSuccess: (datum: any) => void = () => {},
//     onError: (err: AxiosError) => void = () => {},
// ) => {
//     return useMutation(
//         async (code: string) => {
//             try {
//                 const res = await xapi.post(userPartnerConnection, { code });
//                 return res;
//             } catch (Err) {
//                 console.log('saveError>>', Err);
//                 throw Err;
//             }
//         },
//         {
//             onSuccess: onSuccess,
//             onError: onError,
//         },
//     );
// };

// //* 계좌입력
// export const useSaverPaybackBankAccount = (
//     onSuccess: (datum: any) => void = () => {},
//     onError: (err: AxiosError) => void = () => {},
// ) => {
//     return useMutation(
//         async ({ bank, account }: { bank: string; account: string }) => {
//             try {
//                 const res = await xapi.post(userBankAccount, { bank, account });
//                 return res;
//             } catch (Err) {
//                 console.log('saveError>>', Err);
//                 throw Err;
//             }
//         },
//         {
//             onSuccess: onSuccess,
//             onError: onError,
//         },
//     );
// };

// //* 은행리스트
// export const useGetBankList = (enabled: boolean = true) => {
//     const fetchBankList = async () => {
//         const response = await xapi.get(`${bankList}`);
//         return response?.data;
//     };
//     return useQuery<IBankInfoType>(['useGetBankList'], () => fetchBankList(), {
//         enabled,
//     });
// };

//* 추천인 검색리스트
export const useSearchPartner = (name: string) => {
    const fetchSearchPartner = async () => {
        console.log("📡 [2] API 호출 시작: nameOrCode =", name);
        const response = await axiosAsync.get(`${partnerSearchListV2}?nameOrCode=${name}`);
        console.log("📬 [3] 응답 수신:", response.data); // 응답 결과 확인
        return response?.data;
    };

    return useQuery({
        queryKey: ["useSearchPartner", name],
        queryFn: fetchSearchPartner,
        enabled: false,
    });
};
